import { OptimizeConfig, defaultOptimizeConfig } from 'components/optimize/optimize-types';

export type TrackWindow = {
    ga?: any;
    gtag?: any;
    optimizerConfig?: OptimizeConfig;
};

type analyticsReadyCallbackProps = {
    callback(config: OptimizeConfig): void
}

export const analyticsReadyCallback = ({ callback }: analyticsReadyCallbackProps) => {
    const appWindow = window as TrackWindow;

    callback(defaultOptimizeConfig);

    window.addEventListener('load', () => {
        if (!(appWindow.ga && appWindow.ga.create && appWindow.gtag)) {
            callback(defaultOptimizeConfig);
        }
    }, false);

    appWindow.gtag('event', 'optimize.callback', {
        callback: () => {
            callback(
                Object.assign(defaultOptimizeConfig, appWindow.optimizerConfig || {})
            );
        }
    });
};
